// domain/visita.rules.js  (reglas puras; testeables con Jest sin mocks)
import { cuentaPorPadre } from '../../shared/domain/asistentes';
import { nombreUsuario } from '../../shared/domain/usuario';

/** Id de cuenta (productor) de cada visita a partir de la lista plana de asistentes: Map idVisita -> id_cuenta. */
export const productorPorVisita = asistentes => cuentaPorPadre(asistentes, 'id_visita');

/** Ids de productor distintos de las visitas que tienen parcela (solo ellos necesitan su catálogo de parcelas). */
export const productoresConParcela = (list, asistentes = []) => {
  const cuentas = productorPorVisita(asistentes);
  const ids = list.filter(item => item.id_parcela !== null && cuentas.has(item.id)).map(item => cuentas.get(item.id));
  return [...new Set(ids)];
};

/**
 * Agrega campos derivados (solo para mostrar, buscar y exportar): productor (asistente de la visita), parcela y
 * responsable (usuario que registró) resueltos desde los catálogos.
 */
export const withNombres = (list, { productores = [], parcelas = [], usuarios = [], asistentes = [] } = {}) => {
  const cuentas = productorPorVisita(asistentes);
  const productorById = new Map(productores.map(p => [p.id, p]));
  const parcelaById = new Map(parcelas.map(p => [p.id, p.nombre]));
  return list.map(item => {
    const idCuenta = cuentas.get(item.id) || null;
    const productor = idCuenta ? productorById.get(idCuenta) : null;
    return {
      ...item,
      id_cuenta: idCuenta,
      productor_nombre: idCuenta ? (productor ? productor.nombre : `Productor ${idCuenta}`) : '',
      productor_uuid: productor ? productor.uuid : '',
      // Mientras el catálogo carga (o si la parcela no aparece) se muestra el id.
      parcela_nombre: item.id_parcela === null ? '' : parcelaById.get(item.id_parcela) || `Parcela ${item.id_parcela}`,
      responsable_nombre: nombreUsuario(usuarios, item.id_user),
    };
  });
};

export { sortByRecientes } from '../../shared/domain/coleccion';
